// Constantes e variáveis globais
const apiUrl = "https://backend-ezdrop-api-gateway.onrender.com";
let shopifyShopUrl;
let productId;
let metafields;
let nextIndex;
let ratingValue = 5;
let totalReviewsSection = 0;
let starsCountSection = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
let identifiers = new Set();
let reviewsSection = [];
let container = ''
let mediaSection = null
let currentViewMode = 'list';
let paginationLimit = 10;
let currentPageEzReviews = 1;

function initializeVariables() {
    container = document.querySelector('.review-container');
    if (!container) {
        console.error("Elemento .review-container não encontrado.");
        return false;
    }
    shopifyShopUrl = `https://${container.dataset.shopUrl}/`;
    productId = container.dataset.productId;
    metafields = JSON.parse(container.dataset.metafields);
    nextIndex = JSON.parse(container.dataset.nextIndex);
    return true;
}

function getMetafieldsAndFavorites() {
    totalReviewsSection = 0;
    starsCountSection = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    identifiers = new Set();
    reviewsSection = [];

    Object.keys(metafields).forEach(key => {
        if (key.startsWith('review_')) {
            const id = key.replace('review_', '');
            identifiers.add(id);
            const review = metafields[key];
            const { name, comment, rating, photos } = review;
            const sanitizedName = (name || '').trim();
            const sanitizedComment = (comment || '').trim().replace(/\n/g, '<br>');
            const sanitizedRating = parseInt(rating || '5');
            let image = null;
            if (typeof photos === 'string' && photos.trim() !== '') {
                image = photos.trim();
            } else if (Array.isArray(photos) && photos.length > 0) {
                image = photos[0];
            }
            totalReviewsSection++;
            if (sanitizedRating >= 1 && sanitizedRating <= 5) {
                starsCountSection[sanitizedRating]++;
            }
            reviewsSection.push({
                comment: sanitizedComment,
                name: sanitizedName,
                rating: sanitizedRating,
                image: image
            });
        }
    });

    const favoritesString = metafields.favorites || '';
    const favoritesIds = favoritesString.split(',').filter(Boolean);
    const identifiersList = Array.from(identifiers);
    const reviewMap = {};
    reviewsSection.forEach(review => {
        const reviewId = Object.keys(metafields).find(key => key.startsWith('review_') &&
            metafields[key].name.trim().toLowerCase() === review.name.trim().toLowerCase() &&
            metafields[key].comment.trim().toLowerCase() === review.comment.replace(/<br>/g, '\n').trim().toLowerCase());
        if (reviewId) {
            reviewMap[reviewId.replace('review_', '')] = review;
        }
    });

    const sortedReviews = [];
    const processedIds = new Set();
    favoritesIds.forEach(id => {
        if (reviewMap[id]) {
            sortedReviews.push(reviewMap[id]);
            processedIds.add(id);
        }
    });
    identifiersList.forEach(id => {
        if (!processedIds.has(id) && reviewMap[id]) {
            sortedReviews.push(reviewMap[id]);
        }
    });
    reviewsSection = sortedReviews;

    const totalUp = Object.entries(starsCountSection).reduce((sum, [stars, count]) =>
        sum + (parseInt(stars) * count), 0);
    const totalDown = Object.values(starsCountSection).reduce((sum, count) => sum + count, 0);
    mediaSection = totalDown > 0 ? (totalUp / totalDown) : 0;
}

function renderHtml() {
    container.innerHTML = `
    <div class="review-resume" id="ez-review-section">
        <h1>AVALIAÇÕES DE CLIENTES</h1>
        <div class="review-resume-info">
            <div class="review-resume-number">
                <h2>${mediaSection.toFixed(2)}</h2>
                <div class="review-resume-star" style="display:flex; gap:4px; background:transparent; border:none; padding:4px 0;">
                    ${Array(5).fill().map((_, i) => {
                        const filledStars = totalReviewsSection > 0 ? Math.round(mediaSection) : 0;
                        const filled = i < filledStars;
                        return `
                        <svg xmlns="http://www.w3.org/2000/svg" width="40px" height="40px" viewBox="0 0 197.97 188.28">
                            <polygon 
                                fill="${filled ? '#c6b364' : 'none'}"
                                stroke="#c6b364"
                                stroke-width="8"
                                points="98.98 0 129.57 61.98 197.97 71.92 148.48 120.16 160.16 188.28 98.98 156.12 37.81 188.28 49.49 120.16 0 71.92 68.4 61.98 98.98 0"/>
                        </svg>`;
                    }).join('')}
                </div>
                <h3>${totalReviewsSection} Avaliações</h3>
                <div class="review-write-container">
                    <button class="review-btn">Escrever uma avaliação</button>
                </div>
                <div id="review-form" class="review-write-container" style="display: none;">
                    <div style="border-top: 2px solid #ddd; padding:20px;">
                        <span style="font-weight: 700;">Avalie este produto:</span>
                        <div id="star-rating">
                            ${Array(5).fill().map((_, i) => `
    <span class="star" data-value="${i + 1}" style="cursor:pointer;">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 197.97 188.28" width="25px" height="25px">
            <polygon strokeWidth="0px" fill="rgb(200,200,200)" points="98.98 0 129.57 61.98 197.97 71.92 148.48 120.16 160.16 188.28 98.98 156.12 37.81 188.28 49.49 120.16 0 71.92 68.4 61.98 98.98 0"/>
        </svg>
    </span>
`).join('')}
                        </div>
                        <div class="review-field-to-send">
                            <input type="text" id="reviewer-name" placeholder="Seu nome">
                            <input type="file" id="reviewer-image-url" accept="image/*">
                            <textarea id="review-text" placeholder="Descrição"></textarea>
                            <button id="submit-review">Enviar Avaliação</button>
                            <div id="error-message"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="review-resume-star-count">
                ${totalReviewsSection > 0 ? [5, 4, 3, 2, 1].map(stars => {
        const percentage = (starsCountSection[stars] * 100 / totalReviewsSection);
        return `
                        <div class="review-resume-star-count-bar">
                          <div class="ez-resume-number-and-star">
                              <p>${stars}</p>
                                <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px" viewBox="0 0 197.97 188.28">
                                <polygon fill="#c6b364"
                                    points="98.98 0 129.57 61.98 197.97 71.92 148.48 120.16 160.16 188.28 98.98 156.12 37.81 188.28 49.49 120.16 0 71.92 68.4 61.98 98.98 0"/>
                                </svg>
                            </div>
                            <div class="review-progress">
                                <div class="review-progress-fill" style="width: ${percentage}%"></div>
                            </div>
                            <p>${starsCountSection[stars]}</p>
                        </div>
                    `;
    }).join('') : ''}
            </div>
        </div>
    </div>
    <div id="review-view-options">
        <label for="review-mode-select" style="font-weight:bold; margin-right:10px;">Visualização:</label>
        <select id="review-mode-select" class="ez-select-model-review ez-select-model-review-style">
          <option value="list" class="ez-option-model-review-style">Lista</option>
          <option value="carousel" class="ez-option-model-review-style">Carrossel</option>
          <option value="pagination" class="ez-option-model-review-style">Paginação</option>
        </select>
        <select id="pagination-limit" style="display:none; margin-left:10px;" class="ez-select-model-review-style">
          <option value="5" class="ez-option-model-review-style">5 por página</option>
          <option value="10" selected class="ez-option-model-review-style">10 por página</option>
          <option value="20" class="ez-option-model-review-style">20 por página</option>
        </select>
    </div>
    <div class="review-card-container">
        ${reviewsSection.map((review, index) => `
            <div class="review-card" ${index > 9 ? 'style="display: none;"' : ''}>
                ${review.image && !review.image.includes('placehold') ? `
                    <div class="review-image-container">
                        <img class="review-image" src="${review.image}" alt="Review image" loading="lazy">
                    </div>
                ` : ''}
                <h1>${review.name}</h1>
                <div class="review-avaliation">
                    ${Array(5).fill().map((_, i) => `
                        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 197.97 188.28">
                            <polygon fill="${i < review.rating ? '#c6b364' : 'rgb(200, 200, 200)'}"
                                points="98.98 0 129.57 61.98 197.97 71.92 148.48 120.16 160.16 188.28 98.98 156.12 37.81 188.28 49.49 120.16 0 71.92 68.4 61.98 98.98 0"/>
                        </svg>
                    `).join('')}
                </div>
                <div class="description-review-wrapper">
                    <div class="description-review">${review.comment}</div>
                    <a href="javascript:void(0)" class="read-more">Ver mais</a>
                </div>
            </div>
        `).join('')}
    </div>
    <div id="load-more-container" style="text-align: center; margin-top: 20px;">
        <button id="load-more" class="review-btn">Carregar Mais</button>
    </div>
    <div id="review-myModal" class="review-modal">
        <div class="review-modal-content">
            <img id="review-modal-image" src="" alt="Imagem ampliada">
            <span class="review-close">×</span>
        </div>
    </div>
`;
}

function insertStarsSummary(average, totalReviews) {
    let insertAnchor = document.querySelector('.product__title, .product-meta__title, .pp-product-title, .product_title, .product-info__title');
    if (!insertAnchor) {
        const label = document.querySelector('.labels-titulo');
        let el = label ? label.nextElementSibling : null;
        while (el && !el.classList.contains('divider')) { el = el.nextElementSibling; }
        if (el) { insertAnchor = el; }
    }
    if (!insertAnchor) { console.warn("Nenhum título de produto encontrado."); return; }

    const starsSummaryEl = document.createElement('div');
    starsSummaryEl.classList.add('ezdrop-stars-summary');
    starsSummaryEl.style.display = 'flex';
    starsSummaryEl.style.alignItems = 'center';
    starsSummaryEl.style.gap = '5px';
    starsSummaryEl.style.marginTop = '0px';
    starsSummaryEl.style.marginBottom = '0px';

    for (let i = 1; i <= 5; i++) {
        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttribute("width", "16px");
        svg.setAttribute("height", "16px");
        svg.setAttribute("viewBox", "0 0 197.97 188.28");
        const polygon = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
        polygon.setAttribute("points", "98.98 0 129.57 61.98 197.97 71.92 148.48 120.16 160.16 188.28 98.98 156.12 37.81 188.28 49.49 120.16 0 71.92 68.4 61.98 98.98 0");
        polygon.setAttribute("fill", i <= Math.round(average) ? '#c6b364' : 'rgb(200, 200, 200)');
        svg.appendChild(polygon);
        starsSummaryEl.appendChild(svg);
    }

    const countText = document.createElement('span');
    countText.textContent = `(${totalReviews} ${totalReviews === 1 ? 'avaliação' : 'avaliações'})`;
    countText.style.fontSize = '14px';
    countText.style.color = '#444';
    starsSummaryEl.appendChild(countText);
    insertAnchor.insertAdjacentElement('afterend', starsSummaryEl);
    starsSummaryEl.style.cursor = 'pointer';
    starsSummaryEl.addEventListener('click', () => {
        const reviewSection = document.getElementById('ez-review-section');
        if (reviewSection) { reviewSection.scrollIntoView({ behavior: 'smooth' }); }
    });
}

function createReviewCard(review) {
    const div = document.createElement('div');
    div.className = 'review-card';
    if (review.image && !review.image.includes('placehold')) {
        const imgContainer = document.createElement('div');
        imgContainer.className = 'review-image-container';
        const img = document.createElement('img');
        img.src = review.image;
        img.className = 'review-image';
        img.loading = 'lazy';
        imgContainer.appendChild(img);
        div.appendChild(imgContainer);
    }
    const h1 = document.createElement('h1');
    h1.textContent = review.name;
    div.appendChild(h1);
    const stars = document.createElement('div');
    stars.className = 'review-avaliation';
    for (let i = 1; i <= 5; i++) {
        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttribute("width", "20px");
        svg.setAttribute("height", "20px");
        svg.setAttribute("viewBox", "0 0 197.97 188.28");
        const polygon = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
        polygon.setAttribute("points", "98.98 0 129.57 61.98 197.97 71.92 148.48 120.16 160.16 188.28 98.98 156.12 37.81 188.28 49.49 120.16 0 71.92 68.4 61.98 98.98 0");
        polygon.setAttribute("fill", i <= review.rating ? '#c6b364' : 'rgb(200, 200, 200)');
        svg.appendChild(polygon);
        stars.appendChild(svg);
    }
    div.appendChild(stars);
    const descWrap = document.createElement('div');
    descWrap.className = 'description-review-wrapper';
    const comment = document.createElement('div');
    comment.className = 'description-review';
    comment.innerHTML = review.comment;
    const readMore = document.createElement('a');
    readMore.href = 'javascript:void(0)';
    readMore.className = 'read-more';
    readMore.textContent = 'Ver mais';
    descWrap.appendChild(comment);
    descWrap.appendChild(readMore);
    div.appendChild(descWrap);
    return div;
}

function setupImageModal() {
    const modal = document.getElementById("review-myModal");
    const modalImage = document.getElementById("review-modal-image");
    const closeBtn = document.querySelector(".review-close");
    document.querySelectorAll('.review-image').forEach(img => {
        img.onclick = function () { modalImage.src = this.src; modal.style.display = "block"; };
    });
    closeBtn.onclick = () => modal.style.display = "none";
    window.onclick = event => { if (event.target === modal) modal.style.display = "none"; };
}

function renderReviewsView() {
    const container = document.querySelector('.review-card-container');
    container.innerHTML = '';
    container.classList.remove('carousel-mode');
    document.getElementById('load-more-container')?.remove();
    document.getElementById('pagination-controls')?.remove();
    if (currentViewMode === 'list') { renderListView(); }
    else if (currentViewMode === 'carousel') { renderCarouselView(); }
    else if (currentViewMode === 'pagination') { renderPaginationView(); }
    initializeReadMore();
    setupImageModal();
}

function renderListView() {
    const container = document.querySelector('.review-card-container');
    reviewsSection.forEach((review, index) => {
        const card = createReviewCard(review);
        if (index > 9) card.style.display = 'none';
        container.appendChild(card);
    });
    if (reviewsSection.length > 10) {
        const loadMore = document.createElement('button');
        loadMore.className = 'review-btn';
        loadMore.id = 'load-more';
        loadMore.textContent = 'Carregar Mais';
        const div = document.createElement('div');
        div.id = 'load-more-container';
        div.style.textAlign = 'center';
        div.style.marginTop = '20px';
        div.appendChild(loadMore);
        container.parentNode.appendChild(div);
        loadMore.addEventListener('click', () => {
            let shown = 0;
            container.querySelectorAll('.review-card').forEach(card => {
                if (card.style.display === 'none' && shown < 10) { card.style.display = 'flex'; shown++; }
            });
            const hidden = Array.from(container.querySelectorAll('.review-card')).filter(c => c.style.display === 'none');
            if (hidden.length === 0) loadMore.style.display = 'none';
            initializeReadMore();
        });
    }
}

function renderPaginationView() {
    const container = document.querySelector('.review-card-container');
    const start = (currentPageEzReviews - 1) * paginationLimit;
    const end = start + paginationLimit;
    const visible = reviewsSection.slice(start, end);
    visible.forEach(review => container.appendChild(createReviewCard(review)));
    renderPaginationControls();
}

function renderPaginationControls() {
    const totalPages = Math.ceil(reviewsSection.length / paginationLimit);
    const container = document.createElement('div');
    container.id = 'pagination-controls';
    container.className = 'pagination';
    const isMobile = window.innerWidth <= 600;
    function createButton(label, isActive = false, disabled = false, onClick = null) {
        const btn = document.createElement('button');
        btn.className = 'page-btn';
        btn.textContent = label;
        if (isActive) btn.classList.add('active');
        if (disabled) btn.disabled = true;
        if (onClick) btn.addEventListener('click', onClick);
        return btn;
    }
    function createEllipsis() {
        const el = document.createElement('span');
        el.className = 'page-ellipsis';
        el.textContent = '...';
        return el;
    }
    container.appendChild(createButton('«', false, currentPageEzReviews === 1, () => {
        if (currentPageEzReviews > 1) { currentPageEzReviews--; renderReviewsView(); }
    }));
    if (isMobile) {
        if (currentPageEzReviews > 1) {
            container.appendChild(createButton(String(currentPageEzReviews - 1), false, false, () => { currentPageEzReviews--; renderReviewsView(); }));
        }
        container.appendChild(createButton(String(currentPageEzReviews), true));
        if (currentPageEzReviews < totalPages) {
            container.appendChild(createButton(String(currentPageEzReviews + 1), false, false, () => { currentPageEzReviews++; renderReviewsView(); }));
        }
    } else {
        container.appendChild(createButton('1', currentPageEzReviews === 1, false, () => { currentPageEzReviews = 1; renderReviewsView(); }));
        if (currentPageEzReviews > 3) container.appendChild(createEllipsis());
        for (let i = currentPageEzReviews - 1; i <= currentPageEzReviews + 1; i++) {
            if (i > 1 && i < totalPages) {
                container.appendChild(createButton(String(i), currentPageEzReviews === i, false, () => { currentPageEzReviews = i; renderReviewsView(); }));
            }
        }
        if (currentPageEzReviews < totalPages - 2) container.appendChild(createEllipsis());
        if (totalPages > 1) {
            container.appendChild(createButton(String(totalPages), currentPageEzReviews === totalPages, false, () => { currentPageEzReviews = totalPages; renderReviewsView(); }));
        }
    }
    container.appendChild(createButton('»', false, currentPageEzReviews === totalPages, () => {
        if (currentPageEzReviews < totalPages) { currentPageEzReviews++; renderReviewsView(); }
    }));
    document.querySelector('.review-container').appendChild(container);
}

function enableCarouselDragScroll() {
    const container = document.querySelector('.review-card-container.carousel-mode');
    if (!container) return;
    let isDown = false, startX, scrollLeft, velocity = 0, rafId;
    const sensitivity = 1, maxVelocity = 50, friction = 0.92;
    container.addEventListener('mousedown', (e) => { isDown = true; container.classList.add('dragging'); startX = e.pageX; scrollLeft = container.scrollLeft; cancelAnimationFrame(rafId); });
    container.addEventListener('mouseup', () => { isDown = false; container.classList.remove('dragging'); momentumScroll(); });
    container.addEventListener('mouseleave', () => { isDown = false; container.classList.remove('dragging'); });
    container.addEventListener('mousemove', (e) => { if (!isDown) return; e.preventDefault(); const x = e.pageX; const walk = (x - startX) * sensitivity; velocity = Math.max(-maxVelocity, Math.min(maxVelocity, walk)); container.scrollLeft = scrollLeft - walk; });
    function momentumScroll() { velocity *= friction; if (Math.abs(velocity) > 0.5) { container.scrollLeft -= velocity; rafId = requestAnimationFrame(momentumScroll); } }
}

function renderCarouselView() {
    const container = document.querySelector('.review-card-container');
    container.innerHTML = '';
    container.classList.add('carousel-mode');
    container.style.display = 'flex';
    reviewsSection.forEach(review => {
        const card = createReviewCard(review);
        card.style.minWidth = '250px';
        card.style.marginRight = '10px';
        container.appendChild(card);
    });
    enableCarouselDragScroll();
}

function setupViewModeSwitch() {
    const viewSelect = document.getElementById('review-mode-select');
    const paginationSelect = document.getElementById('pagination-limit');
    viewSelect.addEventListener('change', function () {
        currentViewMode = this.value;
        currentPageEzReviews = 1;
        paginationSelect.style.display = currentViewMode === 'pagination' ? 'inline-block' : 'none';
        renderReviewsView();
    });
    paginationSelect.addEventListener('change', function () {
        paginationLimit = parseInt(this.value);
        currentPageEzReviews = 1;
        renderReviewsView();
    });
}

function initializeReadMore() {
    const readMoreLinks = document.querySelectorAll('.description-review-wrapper .read-more');
    readMoreLinks.forEach(link => {
        const reviewText = link.previousElementSibling;
        if (reviewText.scrollHeight <= reviewText.clientHeight) { link.style.display = 'none'; }
        else { link.style.display = 'block'; }
        link.onclick = function () {
            if (reviewText.classList.contains('expanded')) { reviewText.classList.remove('expanded'); link.textContent = 'Ver mais'; }
            else { reviewText.classList.add('expanded'); link.textContent = 'Ver menos'; }
        };
    });
}

function checkStoreEligibility() {
    return fetch(`${apiUrl}/gateway/external-store-datas/is-subscription-active-store-url/${shopifyShopUrl.split("https://")[1]}`, {
        method: 'GET', headers: { 'Content-Type': 'application/json' },
    })
        .then(response => { if (!response.ok) { throw new Error(`Erro: ${response.statusText}`); } return response.json(); })
        .then(data => {
            if (!data.isActive) { document.querySelector('.review-container').style.display = 'none'; }
        })
        .catch(error => { console.error("Erro:", error); document.querySelector('.review-container').style.display = 'none'; });
}

// ALTERADO: Esconde os dois fundos, mantém apenas o SVG dourado
function adjustStarBackground() {
    const starBackgroundFull = document.querySelector('.review-resume-star-background-full');
    const starBackground = document.querySelector('.review-resume-star-background');
    if (starBackgroundFull) {
        starBackgroundFull.style.display = 'none';
        starBackgroundFull.style.background = 'transparent';
    }
    if (starBackground) {
        starBackground.style.display = 'none';
        starBackground.style.background = 'transparent';
    }
}

function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

async function getActiveThemeId(shopifyShopUrl) {
    const requestBody = { storeUrl: shopifyShopUrl };
    try {
        const response = await fetch(`${apiUrl}/infra/shopify/get-theme-id-by-store-url`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(requestBody) });
        const data = await response.json();
        if (data.errors) { return null; }
        const activeTheme = data.find(theme => theme.node.role === "MAIN");
        return activeTheme ? activeTheme.node.id : null;
    } catch (error) { return null; }
}

function processSubmission(imageUrl, reviewerName, reviewText, reviewForm, reviewBtn, submitBtn, imageFileInput) {
    const requestBody = {
        storeUrl: shopifyShopUrl, productShopifyId: productId,
        reviews: [{ name: reviewerName, rating: ratingValue, comment: reviewText, photos: [imageUrl || 'https://placehold.co/600x400?text=No%20Image'] }]
    };
    fetch(`${apiUrl}/infra/shopify/add-all-metafields-product-by-store-url`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(requestBody) })
        .then(response => response.json())
        .then(() => {
            reviewForm.style.display = 'none'; reviewBtn.style.display = 'block';
            document.getElementById('reviewer-name').value = ''; document.getElementById('review-text').value = '';
            imageFileInput.value = ''; ratingValue = 5; submitBtn.textContent = 'Enviar Avaliação'; submitBtn.disabled = false;
        })
        .catch(error => {
            document.getElementById('error-message').textContent = 'Erro ao enviar a avaliação, tente novamente';
            document.getElementById('error-message').style.display = 'block';
            submitBtn.textContent = 'Enviar Avaliação'; submitBtn.disabled = false;
        });
}

document.addEventListener('DOMContentLoaded', function () {
    if (!initializeVariables()) return;
    getMetafieldsAndFavorites();
    renderHtml();
    currentViewMode = 'carousel';
    renderReviewsView();
    insertStarsSummary(mediaSection, totalReviewsSection);
    checkStoreEligibility();

    const reviewBtn = document.querySelector('.review-btn');
    const reviewForm = document.getElementById('review-form');
    const submitBtn = document.getElementById('submit-review');
    const stars = document.querySelectorAll('.star');
    const imageFileInput = document.getElementById('reviewer-image-url');
    let ratingValue = 5;

    adjustStarBackground();
    setupViewModeSwitch();

    reviewBtn.addEventListener('click', () => { reviewForm.style.display = 'flex'; reviewBtn.style.display = 'none'; });

    stars.forEach(star => {
    star.addEventListener('click', function () {
        ratingValue = parseInt(this.getAttribute('data-value'));
        stars.forEach((otherStar, index) => {
            const path = otherStar.querySelector('svg polygon');
            path.setAttribute('fill', index < ratingValue ? '#C9A84C' : 'rgb(200, 200, 200)');
        });
    });
    star.addEventListener('mouseover', function () {
        const hoverValue = parseInt(this.getAttribute('data-value'));
        stars.forEach((otherStar, index) => {
            const path = otherStar.querySelector('svg polygon');
            path.setAttribute('fill', index < hoverValue ? '#C9A84C' : 'rgb(200, 200, 200)');
        });
    });
    star.addEventListener('mouseout', function () {
        stars.forEach((otherStar, index) => {
            const path = otherStar.querySelector('svg polygon');
            path.setAttribute('fill', index < ratingValue ? '#C9A84C' : 'rgb(200, 200, 200)');
        });
    });
});

    submitBtn.addEventListener('click', function (event) {
        event.preventDefault();
        const errorMessage = document.getElementById('error-message');
        errorMessage.style.display = 'none'; errorMessage.textContent = '';
        const reviewerName = document.getElementById('reviewer-name').value.trim();
        const reviewText = document.getElementById('review-text').value.trim();
        const imageFile = imageFileInput.files[0];
        if (!reviewerName || !reviewText) {
            errorMessage.textContent = 'Por favor, preencha todos os campos obrigatórios (Nome e Descrição).';
            errorMessage.style.display = 'block'; submitBtn.textContent = 'Enviar Avaliação'; submitBtn.disabled = false; return;
        }
        submitBtn.textContent = 'Enviando...'; submitBtn.disabled = true;
        if (imageFile) {
            const reader = new FileReader();
            reader.onloadend = async function () {
                const base64Image = reader.result.replace(/^data:image\/(png|jpg|jpeg|webp);base64,/, '');
                const assetKey = `assets/${encodeURIComponent(imageFile.name)}`;
                const themeId = await getActiveThemeId(shopifyShopUrl);
                const themeIdParsed = themeId.split('/').pop();
                const body = { storeUrl: shopifyShopUrl, base64Image, assetKey, themeId: themeIdParsed };
                fetch(`${apiUrl}/infra/shopify/create-asset-value-by-store-url`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
                    .then(response => response.json())
                    .then(data => {
                        if (data?.errors) { processSubmission(undefined, reviewerName, reviewText, reviewForm, reviewBtn, submitBtn, imageFileInput); return; }
                        processSubmission(data.imageUrl, reviewerName, reviewText, reviewForm, reviewBtn, submitBtn, imageFileInput);
                    })
                    .catch(() => processSubmission(undefined, reviewerName, reviewText, reviewForm, reviewBtn, submitBtn, imageFileInput));
            };
            reader.readAsDataURL(imageFile);
        } else {
            processSubmission(undefined, reviewerName, reviewText, reviewForm, reviewBtn, submitBtn, imageFileInput);
        }
    });

    const modal = document.getElementById("review-myModal");
    const span = document.getElementsByClassName("review-close")[0];
    document.querySelectorAll('.review-image').forEach(item => {
        item.onclick = function () { document.getElementById("review-modal-image").src = this.src; modal.style.display = "block"; };
    });
    span.onclick = () => modal.style.display = "none";
    window.onclick = event => { if (event.target == modal) modal.style.display = "none"; };
    initializeReadMore();
    window.addEventListener('resize', () => { if (currentViewMode === 'pagination') { renderReviewsView(); } });
});

function initializeReadMore() {
    const readMoreLinks = document.querySelectorAll('.description-review-wrapper .read-more');
    readMoreLinks.forEach(link => {
        const reviewText = link.previousElementSibling;
        if (reviewText.scrollHeight <= reviewText.clientHeight) { link.style.display = 'none'; }
        else { link.style.display = 'block'; }
        link.removeEventListener('click', handleReadMore);
        link.addEventListener('click', handleReadMore);
    });
}

function handleReadMore(e) {
    e.preventDefault();
    const wrapper = this.closest('.description-review-wrapper');
    const reviewText = wrapper.querySelector('.description-review');
    if (reviewText.classList.contains('expanded')) { reviewText.classList.remove('expanded'); this.textContent = "Ver mais"; }
    else { reviewText.classList.add('expanded'); this.textContent = "Ver menos"; }
}
